import { useCallback, useEffect, useRef, useState } from 'react'
import { getSearchroom } from '../services/searchrooms'

// Caches full searchroom documents by id for the grid. Grid windows persist only
// `entityId`, so on reload we fetch any rooms we don't already have. Callers can
// `seed` a room they already hold (e.g. from the sidebar) to skip the fetch, and
// `remove` one after deletion. Fetches are de-duped per id.
export function useSearchroomCache(entityIds) {
  const [roomsById, setRoomsById] = useState({})
  const pendingRef = useRef(new Set())

  useEffect(() => {
    entityIds.forEach((id) => {
      if (!id || roomsById[id] || pendingRef.current.has(id)) return
      pendingRef.current.add(id)
      getSearchroom(id)
        .then((room) => setRoomsById((prev) => ({ ...prev, [id]: room })))
        .catch(() => {})
        .finally(() => pendingRef.current.delete(id))
    })
  }, [entityIds, roomsById])

  const seed = useCallback((room) => {
    if (room?._id) setRoomsById((prev) => ({ ...prev, [room._id]: room }))
  }, [])

  const remove = useCallback((id) => {
    setRoomsById((prev) => {
      if (!(id in prev)) return prev
      const next = { ...prev }
      delete next[id]
      return next
    })
  }, [])

  return { roomsById, seed, remove }
}
